import React from "react";
import { BadgeCheck, Handshake } from "lucide-react";

/** Partner badge shown ONLY for schools with subscription_tier === "premium".
 *  Renders both a blue "Verified" badge and a gold "Partner" badge — a small
 *  double-mark that signals this school has signed a partnership with the
 *  platform, distinct from the community-driven Trusted-by-Verified-Parents badge. */
export default function PartnerBadge({ school, size = "sm" }) {
  if (school?.subscription_tier !== "premium") return null;
  const pad = size === "lg" ? "px-3 py-1.5" : "px-2 py-0.5";
  const textSize = size === "lg" ? "text-xs" : "text-[10px]";
  const iconSize = size === "lg" ? 12 : 10;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="partner-badge">
      <span className={`inline-flex items-center gap-1 ${pad} rounded-full bg-[#DBEAFE] text-[#1E3A8A] ${textSize} uppercase tracking-wider border border-[#93C5FD] font-semibold`}>
        <BadgeCheck size={iconSize} /> Verified
      </span>
      <span className={`inline-flex items-center gap-1 ${pad} rounded-full bg-[#FEF3C7] text-[#92400E] ${textSize} uppercase tracking-wider border border-[#FDE68A] font-semibold`}>
        <Handshake size={iconSize} /> Partner
      </span>
    </span>
  );
}
